import { Tabs } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/store';
import { viewerModel } from 'entities/viewer';
import { RolesUser } from 'shared/enums';
import { configTabs } from 'shared/helpers/utils';
import { useScrollUpPage, useTabsNavigate } from 'shared/hooks';
import { TItemsTab } from 'shared/types/types';
import { uiModel } from 'entities/ui';
import { useEffect } from 'react';
import Divisions from './divisions';
import Archive from './archive';

import style from './index.module.scss';

const itemsTab: TItemsTab = [
  {
    label: 'Замещения',
    key: 'new',
    children: <Divisions />,
    role: [RolesUser.HRDirector, RolesUser.FirstLine, RolesUser.SecondLine],
  },
  {
    label: 'Архив замещений',
    key: 'other',
    children: <Archive />,
    role: [RolesUser.HRDirector, RolesUser.FirstLine, RolesUser.SecondLine],
  },
];

export const Substitutions = () => {
  const dispatch = useAppDispatch();

  const [activeTab, handler] = useTabsNavigate('substitutions', itemsTab[0].key);

  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const { page } = useAppSelector(uiModel.Substitutions.selectors.getPagination);

  const tabPane = configTabs(role, itemsTab);

  useScrollUpPage(page);

  // очищаю стор при переключении табов
  useEffect(
    () => () => {
      dispatch(uiModel.Substitutions.actions.resetSubstitutionsUiState());
    },
    [],
  );
  // очищаю стор  при уходе со страницы
  useEffect(() => {
    if (activeTab) {
      dispatch(uiModel.Substitutions.actions.resetSubstitutionsUiState());
    }
  }, [activeTab]);

  return (
    <div className={style.wrap}>
      {role && (
        <Tabs activeKey={activeTab} onChange={handler} destroyInactiveTabPane>
          {tabPane &&
            tabPane?.map(el => {
              return (
                <Tabs.TabPane tab={el.label} key={el.key}>
                  {el.children}
                </Tabs.TabPane>
              );
            })}
        </Tabs>
      )}
    </div>
  );
};
